import { Box, type BoxProps } from "@chakra-ui/react";

function CardTitle({ children, backgroundColor }: BoxProps) {
	return (
		<Box
			borderBottom="solid 1px"
			borderColor="gray.200"
			borderTopRadius="md"
			backgroundColor={backgroundColor}
			px="20px"
			py="20px"
		>
			{children}
		</Box>
	);
}

export default CardTitle;
